<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Group 109895">
      <path id="Line 2635" d="M12.5 12.5L27.5 27.5" stroke="#707070" stroke-width="3" stroke-linecap="round" />
      <path id="Line 2636" d="M27.5 12.5L12.5 27.5" stroke="#707070" stroke-width="3" stroke-linecap="round" />
    </g>
  </svg>
</template>
